(function(){
  var d=document,root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var b=d.querySelector('[data-burger]'),m=d.getElementById('mnav');
  if(b&&m)b.addEventListener('click',function(){var o=m.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false')});
  d.querySelectorAll('[data-gal]').forEach(function(g){
    var main=g.querySelector('[data-gal-main]'),th=g.querySelectorAll('[data-gal-thumb]'),tm;
    if(!main||!th.length)return;
    function set(i){th.forEach(function(t,j){t.setAttribute('aria-current',j===i?'true':'false')})}
    th.forEach(function(t,i){t.addEventListener('click',function(){main.scrollTo({left:main.clientWidth*i,behavior:'smooth'});set(i)})});
    main.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(function(){set(Math.round(main.scrollLeft/main.clientWidth))},90)},{passive:true});
  });
  var drw=d.getElementById('cart-drawer');
  if(!drw||!drw.showModal)return;
  function show(){if(!drw.open)drw.showModal()}
  function paint(s){
    if(!s||!s['cart-drawer'])return;
    var t=d.createElement('div');t.innerHTML=s['cart-drawer'];
    var n=t.querySelector('[data-cart-root]'),o=drw.querySelector('[data-cart-root]');
    if(!n||!o)return;
    o.innerHTML=n.innerHTML;
    var c=o.querySelector('[data-count]'),v=c?c.getAttribute('data-count'):'0';
    d.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=v;e.hidden=v==='0'});
  }
  function post(path,body){
    return fetch(root+path,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:body}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
  }
  d.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('form[action$="/cart/add"]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'),err=f.querySelector('[data-err]'),fd=new FormData(f);
    fd.append('sections','cart-drawer');
    if(btn)btn.disabled=true;
    if(err)err.textContent='';
    drw.classList.add('is-loading');
    show();
    post('cart/add.js',fd).then(function(j){
      drw.classList.remove('is-loading');
      paint(j.sections);
    }).catch(function(x){
      drw.classList.remove('is-loading');
      if(drw.open)drw.close();
      if(err)err.textContent=(x&&(x.description||x.message))||'Could not add to cart. Please try again.';
    }).then(function(){if(btn)btn.disabled=false});
  });
  d.addEventListener('click',function(e){
    var t=e.target;
    if(!t.closest)return;
    if(t.closest('[data-cart-open]')){e.preventDefault();show();return}
    if(t===drw||t.closest('[data-cart-close]')){drw.close();return}
    var l=t.closest('#cart-drawer [data-line]');
    if(l){
      e.preventDefault();
      drw.classList.add('is-busy');
      var p=new URLSearchParams();
      p.append('line',l.getAttribute('data-line'));
      p.append('quantity',l.getAttribute('data-qty'));
      p.append('sections','cart-drawer');
      post('cart/change.js',p).then(function(j){paint(j.sections)}).catch(function(){}).then(function(){drw.classList.remove('is-busy')});
    }
  });
})();